import type { OrganizationPaymentTrial } from '../types/auth';

/**
 * Reads an `OrganizationPaymentTrial` off a server response through guards rather than a cast.
 *
 * Web and the API deploy separately, so the field can be absent (an older API) or malformed. Either
 * reads as null, meaning "no trial", which shows no banner and changes no access: blocking is
 * decided by `organizationAwaitingPayment` alone.
 */
export const parsePaymentTrial = (value: unknown): OrganizationPaymentTrial | null => {
  if (typeof value !== 'object' || value === null) return null;
  const { trialEndsAt, daysRemaining, ended, hardStop } = value as Record<string, unknown>;

  if (typeof trialEndsAt !== 'string' || !trialEndsAt.trim()) return null;
  if (typeof daysRemaining !== 'number' || !Number.isFinite(daysRemaining)) return null;
  if (typeof ended !== 'boolean' || typeof hardStop !== 'boolean') return null;

  return {
    trialEndsAt,
    daysRemaining: Math.max(0, Math.floor(daysRemaining)),
    ended,
    hardStop,
  };
};
